export default {
  PRODUCT_SURVEY: 'h16ClkPt',
  NPS_SURVEY: 'RhfSxh7B'
}
